import React, { Component } from 'react';

export default class NSA extends Component {
    render() {
        return <div>
            <section class="features" id="nsa">
                <div class="container mt-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-12">
                            <div class="text-center">
                                <h6 class="text-gradiant fw-bold"></h6>
                                <br /> <br />
                                <div classNme="p-3 bg-red">
                                    <br/> <br/>  <br/>
                                    <h1 class="fw-bold">NOTs Supporting Artist (NSA) program</h1>
                                </div>
                                {/* <div class="d-flex align-items-center mt-4">
                        <button class="btn btn-primary">Explore Now</button>
                        <button class="btn btn-outline-dark ms-4">Create Account</button>
                    </div> */}
                                <br /> <br />
                                <h6 className='text-white'>
                                    NOTs is starting its NOTs Supporting Artist (NSA) program .  We have limited spots available to help independent artists navigate into NFTs.  The NSA will provide promotions on Twitter and Twitter Spaces, listing on Discord and in website, and engineering of Art into NFTs.  Commission is only 15%, so the artist keeps most of what they make!
                                </h6>
                                <h6>
                                    It is another way for NOTs to give back
                                </h6>

                                <br/> <br/>  <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="container mt-5">
                <div class="row justify-content-center">
                <div class="col-lg-9 card p-2">
                    <div class="row align-items-center">
                        <div class="col-lg-5 col-md-6 my-4 my-lg-0">
                            <div class="art-image p-lg-4">
                                <img src="images/cosmic_cats.jpeg" alt="" class="img-fluid bg-black"/>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="body-content">
                                <div class="d-flex">
                                    <div class="title">
                                        <h4 class="fw-bold text-uppercase">COSMIC CATS @ A Stargaze Genesis Collection</h4>
                                    </div>
                                </div>
                                <div class="text-content">
                                    <div class="small-title mb-3">
                                        <p class="f-14 fw-semibold">An abstract adventure through the Cosmic Cat universe, a futuristic reality where the population is primarily made up of hyper intelligent cats (with some pockets of other K9-like life forms). They live amongst a universe comprised of elements of the Cosmos ecosystem. </p>
                                        <p class="f-14 fw-semibold">The Cosmic Cat collection snapshots the lives of these creatures from various perspectives.</p>
                                    </div>
                                    
                                    <div class="d-flex mt-4">
                                        <a class="btn btn-primary rounded-pill" href="https://twitter.com/Ns_JNR"><i class="fab fa-twitter"></i></a>
                                        {/* <div class="ms-2">
                                            <button class="btn btn-outline-primary rounded-pill">Buy now</button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>;
    }
}
